// extracted by mini-css-extract-plugin
module.exports = {"panel__title":"main_faqs_shared--panel__title","panel__body":"main_faqs_shared--panel__body"};